import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { btnOutline } from '../ui';

const API = process.env.REACT_APP_API_URL || '/api';

// **tučně** uvnitř řádku
function inline(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((c, i) =>
    c.startsWith('**') ? <strong key={i}>{c.slice(2, -2)}</strong> : c
  );
}

// Minimální vykreslení CHANGELOG.md: #, ##, odrážky (i vnořené po 2 mezerách) a odstavce.
function Markdown({ text }) {
  const bloky = [];
  text.split('\n').forEach((radek, i) => {
    const odrazka = radek.match(/^(\s*)- (.*)$/);
    if (radek.startsWith('## ')) bloky.push(<h2 key={i} style={{ fontSize: '18px', color: '#333', margin: '28px 0 8px' }}>{inline(radek.slice(3))}</h2>);
    else if (radek.startsWith('# ')) bloky.push(<h1 key={i} style={{ fontSize: '24px', color: '#333', margin: '0 0 8px' }}>{inline(radek.slice(2))}</h1>);
    else if (odrazka) bloky.push(<div key={i} style={{ display: 'flex', gap: '8px', margin: `4px 0 4px ${odrazka[1].length * 8}px`, fontSize: '14px', color: '#333', lineHeight: 1.5 }}><span>•</span><span>{inline(odrazka[2])}</span></div>);
    else if (radek.trim()) bloky.push(<p key={i} style={{ fontSize: '14px', color: '#6b7280', margin: '4px 0' }}>{inline(radek)}</p>);
  });
  return <>{bloky}</>;
}

function CoJeNoveho({ setStranka }) {
  const [text, setText] = useState(null);
  const [chyba, setChyba] = useState('');

  useEffect(() => {
    axios.get(`${API}/changelog`)
      .then(res => setText(res.data.markdown))
      .catch(() => setChyba('Seznam změn se nepodařilo načíst.'));
  }, []);

  return (
    <div>
      <button onClick={() => setStranka('rozcesti')} style={{ ...btnOutline, marginBottom: '14px' }}>← Zpět</button>
      <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0', padding: '16px 20px' }}>
        {chyba ? <p style={{ color: '#b91c1c' }}>{chyba}</p> : text === null ? <p>Načítám…</p> : <Markdown text={text} />}
      </div>
    </div>
  );
}

export default CoJeNoveho;
